import { useTranslation } from "react-i18next";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import CalendarEventItem from "../components/CalendarEventItem";
import Error from "../../../components/Error";
import { Plus } from "@rsuite/icons";

const useStyles = makeStyles(() => ({
  textLight: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "start",
    marginRight: "10px",
  },
  noEventsText: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "center",
    marginRight: "10px",
  },
  mainContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
    padding: "10px",
  },
  divider: {
    height: "1px",
    backgroundColor: "#bcbcbc",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "end",
  },
  picker: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  input: {
    width: "300px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  newEventButton: {
    minWidth: "120px",
    width: "auto",
    height: "35px",
    border: "solid black 1px",
    color: "grey",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
}));

const CalendarEventView = ({
  events,
  loading,
  error,
  onSetStartDate,
  onNewEventClick,
  onDeleteEvent,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.horizontalBox}>
        <Button className={classes.newEventButton} onClick={onNewEventClick}>
          <Plus style={{ marginRight: "7px" }} />
          {t("calendar_event.add_new_event")}
        </Button>
      </Box>
      <Box className={classes.picker}>
        <Typography className={classes.textLight}>
          {t("calendar_event.select_date")}
        </Typography>
        <input
          type="date"
          id="start-time"
          className={classes.input}
          onChange={(e) => onSetStartDate(e.target.value)}
        />
      </Box>
      {error && <Error message={error.message} />}
      {events &&
        events?.map((e) => (
          <CalendarEventItem
            key={e.EVENT_ID}
            event={e}
            onDeleteEvent={() => onDeleteEvent(e.EVENT_ID)}
          />
        ))}
      {!events?.length && !loading && !error && (
        <Typography className={classes.noEventsText}>
          {t("calendar_event.no_events_in_list")}
        </Typography>
      )}
    </Box>
  );
};

export default CalendarEventView;
